import { DateTime } from 'luxon';

import { ReportApi } from '../../api/models';
import { ShortRecipient } from './short-recipient';
import { ScheduleDescription } from './schedule-description';
import { ReptConstants, TemplateVersion } from '../../rept.constants';

export class Report
{
    public reportId: string;
    public active: boolean;
    public createdAt: string;
    public modifiedAt: string;
    public entityId: string;
    public name: string;
    public templateId: string;
    public templateName: string;
    public applicationName: string;
    public description: string;
    public cultureName?: string;
    public isContractual: boolean;
    public externalRecipients: ShortRecipient[];
    public internalRecipients: string[];
    public scheduleDescription: ScheduleDescription;
    public detailedPeriodicity: string;
    public detailedVisibility: string;
    public lastScheduleUTC: DateTime;
    public nextScheduleUTC: DateTime;
    public averageGenDuration: string;
    public averageFullDuration: string;
    public version: TemplateVersion;
}

export class DomainReport extends Report
{
    public static mapperFromApi (source: ReportApi): Report
    {
        const target = new Report();

        Object.assign(target, source);

        target.scheduleDescription = ScheduleDescription.mapperFromApi(source.scheduleDescription);
        // Pour faciliter le tri de la liste
        target.lastScheduleUTC = target.scheduleDescription.lastScheduleUTC;
        target.nextScheduleUTC = target.scheduleDescription.nextScheduleUTC;

        target.detailedPeriodicity = ReptConstants.GetPeriodicities(target.scheduleDescription.periodicity);

        target.name = source.name;

        // if (AppConstants.IsDebugStage)
        // {
        //     target.internalRecipients.push('ab84a3b3-5389-460e-a594-f21047c5ee7d');
        //     target.externalRecipients.push(new ShortRecipient('jean.aimarre@boiteauxlettres.fr', 'Jean', 'Aimarre'));
        // }

        // delete target['reportDetails'];

        return target;
    }
}
